<script>
  import SvelteTable from 'svelte-table';
  import { formatNumber } from '../utils';
  export let rows;
  export let columns = {};
  $: columns = columns.map((column) => {
    return {
      key: column['key'],
      title: column['title'],
      sortable: column['sortable'],
      class: column['align'],
      headerClass: column['headerClass'],
      value: (v) => {
        return formatNumber(v[column['key']], column['format']);
      },
    };
  });
</script>

<div class="table sb-scrollbar sb-scrollbar-horizontal">
  <SvelteTable {columns} {rows} classNameRow={['table-row']} classNameCell={['table-cell']} classNameTbody={['table-body']} />
</div>

<style>.table{overflow-x:scroll;width:100%}.table :global(table){border-collapse:collapse;width:100%}.table :global(:is(td,th)){border-bottom:1px solid #ddd;padding:.5rem}.table :global(:is(td,th)){border-right:1px solid #ddd;font-size:14px}.table :global(td:first-of-type){white-space:nowrap}.table :global(td:last-of-type),.table :global(th:last-of-type){border-right:none}.table :global(:is(td.right)){text-align:right}.table :global(:is(td.center)){text-align:center}.table :global(:is(td.left)){text-align:left}</style>
